import { render } from "./V2RecentActivity.vue?vue&type=template&id=2c0492f8&scoped=true"
import script from "./V2RecentActivity.vue?vue&type=script&lang=js"
export * from "./V2RecentActivity.vue?vue&type=script&lang=js"

import "./V2RecentActivity.vue?vue&type=style&index=0&id=2c0492f8&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c0492f8"]])

export default __exports__